module.exports = __webpack_public_path__ + "static/media/247_icon_white.459ccc04.svg";